import PropTypes from 'prop-types';
import React from 'react';

import AttributeDef, { AttributeType } from 'models/configuration/attribute_def';
import VisiblePercentCustomAttribute from './visible_percent_custom_attribute';
import VisibleStringCustomAttribute from './visible_string_custom_attribute';
import moment from 'moment';

export default function VisibleCustomAttribute({ className, def, value, renderProps, location }) {
  if (!value) {
    return null;
  }

  if (def.type === 'PERCENT') {
    return <VisiblePercentCustomAttribute def={def} className={className} value={value} renderProps={renderProps} />;
  }

  return <VisibleStringCustomAttribute def={def} className={className} value={value} location={location} />;
}

export function formatValue(value, defType) {
  if (defType === AttributeType.DATE) {
    if (value.indexOf('T') !== -1) {
      return moment(value).format('MMM D, YYYY h:mm A');
    }
    return moment(value).format('MMM D, YYYY');
  }
  return value;
}

VisibleCustomAttribute.propTypes = {
  className: PropTypes.string,
  def: PropTypes.instanceOf(AttributeDef).isRequired,
  value: PropTypes.any,
  renderProps: PropTypes.object,
  location: PropTypes.shape({
    type: PropTypes.string,
    subType: PropTypes.string,
  }),
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attributes/visible_custom_attribute.jsx